import { _axios } from "@/plugins/axios";

class CentrosAtencionService {
  async getCentrosAtencion() {
    return _axios.get("/centros-atencion").then((response: any) => {
      return response.data;
    });
  }
}

export default new CentrosAtencionService();
